import { Helmet } from 'react-helmet'
import Header from '../../../../Components/Header'
import MainContent from './mainContent'
const Itemtax = () => {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '99.7vh' }}>
      <Helmet>
				<title>Item Tax Template List</title>
			</Helmet>
    <Header />
    <MainContent />
    </div>
  )
}
export default Itemtax